import React from 'react';
import BusinessIcon from '@material-ui/icons/Business';

const LocationIcon = () => {
  return (
    <BusinessIcon style={{
      color: '#061E44',
      width: '16px',
      height: '16px',
    }} />
  );
};

export default LocationIcon;

